// Global lightbox functions for external lightbox element (outside Vue scope)
// Move lightbox to body level on init so it stacks above header
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const lightbox = document.getElementById('cfluorLightbox');
    if (lightbox && lightbox.parentNode !== document.body) {
      document.body.appendChild(lightbox);
    }
  });
})();

// Scroll-to-top button initialization
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const scrollTopBtn = document.getElementById('cfluorScrollTop');
    if (!scrollTopBtn) return;

    // Move button to body level so position: fixed works correctly
    if (scrollTopBtn.parentNode !== document.body) {
      document.body.appendChild(scrollTopBtn);
    }

    const SCROLL_THRESHOLD = 400;
    let ticking = false;

    // Show/hide button based on scroll position
    function updateScrollTopVisibility() {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollY > SCROLL_THRESHOLD) {
        scrollTopBtn.classList.add('CFluorScrollTop--visible');
      } else {
        scrollTopBtn.classList.remove('CFluorScrollTop--visible');
      }
      ticking = false;
    }

    // Throttled scroll handler using requestAnimationFrame
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollTopVisibility);
        ticking = true;
      }
    }

    // Scroll to top with smooth animation
    function scrollToTop() {
      // Add ripple effect
      scrollTopBtn.classList.add('CFluorScrollTop--ripple');
      setTimeout(function () {
        scrollTopBtn.classList.remove('CFluorScrollTop--ripple');
      }, 600);

      // Smooth scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }

    // Event listeners
    window.addEventListener('scroll', onScroll, { passive: true });
    scrollTopBtn.addEventListener('click', scrollToTop);

    // Initial check in case page is already scrolled
    updateScrollTopVisibility();
  });
})();

window.openCFluorLightbox = function (imageUrl, caption) {
  const lightbox = document.getElementById('cfluorLightbox');
  const img = document.getElementById('cfluorLightboxImage');
  const captionEl = document.getElementById('cfluorLightboxCaption');
  if (!lightbox || !img) return;
  img.src = imageUrl || '';
  if (captionEl) {
    captionEl.innerHTML = caption || '';
    captionEl.style.display = caption ? '' : 'none';
  }
  lightbox.style.display = '';
  document.body.style.overflow = 'hidden';
};

window.closeCFluorLightbox = function () {
  const lightbox = document.getElementById('cfluorLightbox');
  if (!lightbox) return;
  // Add fade-out class for animation
  lightbox.classList.add('CFluorLightbox--closing');
  // Wait for animation to complete before hiding
  setTimeout(function () {
    lightbox.style.display = 'none';
    lightbox.classList.remove('CFluorLightbox--closing');
    document.body.style.overflow = '';
  }, 200);
};

class CFluorPageController {
  initialize(d) {
    // Parse config BEFORE Vue init
    let data = {};
    try {
      data = typeof d === 'string' ? JSON.parse(d) : d || {};
    } catch (e) {
      console.error('Invalid config passed to CFluorPageController:', e);
      data = {};
    }

    new Vue({
      el: '#cFluorPage',
      data() {
        return {
          configuration: '5L_UV_V_B_YG_R',
          source: data,
          activeTab: 'overview',
          activeProductByColor: {},
        };
      },
      created() {
        // Ensure the selected configuration exists
        const confs = this.source?.configurations || {};
        if (!confs[this.configuration]) {
          const keys = Object.keys(confs);
          if (keys.length) this.configuration = keys[0];
        }
      },
      methods: {
        toItemKey(p) {
          // Now also accepts `B-BYG575`
          const m = String(p).match(/[A-Za-z-]+\d+/);
          return m ? m[0].toUpperCase() : null;
        },
        setTab(id) {
          this.activeTab = id;
        },
        rowsByColor(key) {
          return this.tableRows.filter((r) => r.colorKey === key);
        },
        itemsByColor(colorKey) {
          const confKey = this.configuration;
          const confObj = this.source?.configurations?.[confKey];
          if (!confObj) return [];
          const products = (confObj.products || []).filter(Boolean);
          const result = [];
          products.forEach((p) => {
            const key = this.toItemKey(p);
            const item = key && this.source?.items?.[key] ? this.source.items[key] : null;
            if (!item) return;
            if (item.color !== colorKey) return;

            // Build full display name with required prefix "Cytek® cFluor® ..."
            const fullNameHtml = this.fullNameHtmlFor(item, p || key || '-');

            result.push({
              __key: key,
              ...item,
              fullNameHtml,
            });
          });
          return result;
        },
        selectProduct(colorKey, itemKey) {
          const map = { ...(this.activeProductByColor || {}) };
          map[colorKey] = itemKey || null;
          this.activeProductByColor = map;
        },
        navigateToProduct(row) {
          if (!row) return;
          const targetTabId = this.configuration + '-' + row.colorKey;
          // Set product BEFORE switching tab to prevent watcher from overwriting
          this.selectProduct(row.colorKey, row.itemKey);
          this.$nextTick(() => {
            this.activeTab = targetTabId;
            this.$nextTick(() => {
              const id = 'productTabContent';
              const el = document.getElementById(id);
              if (el && typeof el.scrollIntoView === 'function') {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            });
          });
        },
        productInfo(colorKey) {
          const key = this.activeProductByColor?.[colorKey];
          if (!key) return null;
          return this.source?.items?.[key] || null;
        },
        // Compute relative signal percent for an item based on current configuration
        brightnessPercentForItem(item) {
          if (!item) return null;
          const confKey = this.configuration;
          const byConf = item.brightness_by_configuration;
          if (byConf && byConf[confKey] != null) {
            const val = Number(byConf[confKey]);
            if (!isNaN(val)) return Math.max(0, Math.min(100, val));
          }
          return null;
        },
        // Build full display name with required prefix "Cytek® cFluor® ..." avoiding duplication
        fullNameHtmlFor(item, fallback) {
          const baseNameHtml = item?.product_name
            ? item.product_name // already contains cFluor® and HTML entities
            : item?.name
            ? `${item.name}`
            : fallback || '-';
          return `${baseNameHtml}`;
        },
        // Resolve a color hex from a color key (used in details progress bar)
        colorHexForColorKey(key) {
          if (!key) return null;
          return this.source?.colors?.[key]?.hex || null;
        },
        // Lightbox methods - use vanilla JS to control external lightbox element
        openLightbox(imageUrl, caption) {
          window.openCFluorLightbox(imageUrl, caption);
        },
        closeLightbox() {
          window.closeCFluorLightbox();
        },
      },
      computed: {
        // Build options from JSON (no color at config level anymore)
        selectOptions() {
          const confs = this.source?.configurations || {};
          return Object.keys(confs).map((key) => {
            const conf = confs[key];
            return {
              value: key,
              label: conf.title || key,
            };
          });
        },

        // Table rows, now also compute rowColorHex from each item.color
        tableRows() {
          const confKey = this.configuration;
          const confObj = this.source?.configurations?.[confKey];
          if (!confObj) return [];

          const products = (confObj.products || []).filter(Boolean);

          return products.map((p) => {
            const key = this.toItemKey(p);
            const item = key && this.source?.items?.[key] ? this.source.items[key] : null;

            // item.color -> lookup in source.colors
            const itemColorKey = item?.color;

            const colorRef = itemColorKey ? this.source?.colors?.[itemColorKey] : null;

            const brightnessPct = item ? this.brightnessPercentForItem(item) : null;

            // Build full display name with required prefix "Cytek® cFluor® ..."
            const fullNameHtml = this.fullNameHtmlFor(item, p || '-');

            return {
              itemKey: key || null,
              colorKey: itemColorKey || null,
              colorName: colorRef?.name || itemColorKey || '-',
              colorHex: colorRef?.hex || null,

              name: item?.name || p || '-',
              fullNameHtml,
              peak_emission: item?.peak_emission || '-',
              brightnessPct: brightnessPct,
              peak_channel: item?.peak_channel || '-',
              chemistry: item?.chemistry || '-',
              link: item?.link_url || null,
            };
          });
        },
        // Group rows by color for desktop layout where the color cell should span
        // the number of items in that color (rowspan-like behavior)
        groupedTableRows() {
          const rows = this.tableRows || [];
          const order = [];
          const groups = {};
          rows.forEach((r) => {
            const k = r.colorKey || '__unknown__';
            if (!groups[k]) {
              groups[k] = { colorKey: r.colorKey, colorName: r.colorName, colorHex: r.colorHex, rows: [] };
              order.push(k);
            }
            groups[k].rows.push(r);
          });
          return order.map((k) => groups[k]);
        },
        // Dynamic tabs from colors present in current configuration
        colorTabs() {
          const rows = this.tableRows;
          const seen = new Set();
          const result = [];
          rows.forEach((r) => {
            const key = r.colorKey;
            if (!key || seen.has(key)) return;
            const colorRef = this.source?.colors?.[key];
            if (!colorRef) return;
            seen.add(key);
            result.push({
              key,
              id: `${this.configuration}-${key}`,
              title: colorRef.tab_name || colorRef.name || key,
            });
          });
          return result;
        },
      },
      watch: {
        // When the set of tabs changes (usually after configuration change),
        // ensure activeTab points to a valid tab id. Default to the first tab.
        colorTabs: {
          handler(newTabs) {
            const tabs = Array.isArray(newTabs) ? newTabs : [];
            if (!tabs.length) {
              this.activeTab = null;
              this.activeProductByColor = {};
              return;
            }
            const exists = tabs.some((t) => t.id === this.activeTab);
            if (!exists) this.activeTab = tabs[0].id;

            // Initialize/cleanup active product per color
            const nextMap = {};
            tabs.forEach((t) => {
              const colorKey = t.key;
              const items = this.itemsByColor(colorKey);
              if (!items.length) return;
              const currentKey = this.activeProductByColor?.[colorKey];
              const stillExists = !!items.find((it) => it.__key === currentKey);
              nextMap[colorKey] = stillExists ? currentKey : items[0].__key;
            });
            this.activeProductByColor = nextMap;
          },
          immediate: true,
        },
        // When user switches tabs manually, ensure there's a selected product for that color
        activeTab(newId) {
          if (!newId) return;
          const tabs = this.colorTabs || [];
          const found = tabs.find((t) => t.id === newId);
          if (!found) {
            return;
          }
          const colorKey = found.key;
          const items = this.itemsByColor(colorKey);
          if (!items.length) return;
          // Only set first item if no product is already selected for this color
          const currentKey = this.activeProductByColor?.[colorKey];
          const hasValidSelection = currentKey && items.some((it) => it.__key === currentKey);
          if (!hasValidSelection) {
            this.selectProduct(colorKey, items[0].__key);
          }
          // Re-apply tab selection after Vue reactivity settles to ensure content displays
          setTimeout(() => this.setTab(newId), 250);
        },
        configuration() {
          // Let colorTabs watcher pick the first available tab and init product selections for the new configuration
          this.activeTab = null;
          this.activeProductByColor = {};
        },
      },
    });
  }
}
